import { useTranslation } from "react-i18next";

const channels = [
  {
    key: "support",
    icon: "ri-customer-service-2-line",
    color: "#4ade80",
    bg: "rgba(34,197,94,0.1)",
    links: [
      { icon: "ri-github-line", href: "https://github.com/openimsdk/open-im-server/issues", labelKey: "contact.channel.support.link1" },
      { icon: "ri-question-answer-line", href: "https://join.slack.com/t/openimsdk/shared_invite/zt-22720d66b-o_FvKxMTGXtcnnnHiMqe9Q", labelKey: "contact.channel.support.link2" },
    ],
  },
  {
    key: "business",
    icon: "ri-briefcase-4-line",
    color: "#34d399",
    bg: "rgba(52,211,153,0.1)",
    links: [
      { icon: "ri-mail-line", href: "mailto:contact@tupim.io", labelKey: "contact.channel.business.link1" },
      { icon: "ri-wechat-line", href: "#", labelKey: "contact.channel.business.link2" },
    ],
  },
  {
    key: "media",
    icon: "ri-newspaper-line",
    color: "#6ee7b7",
    bg: "rgba(110,231,183,0.1)",
    links: [
      { icon: "ri-mail-line", href: "mailto:press@tupim.io", labelKey: "contact.channel.media.link1" },
      { icon: "ri-twitter-x-line", href: "https://twitter.com/OpenIMSDK", labelKey: "contact.channel.media.link2" },
    ],
  },
  {
    key: "community",
    icon: "ri-community-line",
    color: "#a7f3d0",
    bg: "rgba(167,243,208,0.1)",
    links: [
      { icon: "ri-slack-line", href: "https://join.slack.com/t/openimsdk/shared_invite/zt-22720d66b-o_FvKxMTGXtcnnnHiMqe9Q", labelKey: "contact.channel.community.link1" },
      { icon: "ri-github-line", href: "https://github.com/openimsdk", labelKey: "contact.channel.community.link2" },
    ],
  },
];

export default function ContactChannels() {
  const { t } = useTranslation();
  return (
    <section className="py-16 border-t" style={{ borderColor: "var(--border-color)" }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {channels.map((ch) => (
            <div
              key={ch.key}
              className="rounded-2xl p-6"
              style={{
                backgroundColor: "var(--bg-surface)",
                border: "1px solid var(--border-color)",
              }}
            >
              {/* Header */}
              <div className="flex items-start gap-4 mb-4">
                <div
                  className="w-11 h-11 flex items-center justify-center rounded-xl shrink-0"
                  style={{ backgroundColor: ch.bg, color: ch.color }}
                >
                  <i className={`${ch.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold mb-1" style={{ color: "var(--text-primary)" }}>
                    {t(`contact.channel.${ch.key}.title`)}
                  </h3>
                  <p className="text-xs leading-relaxed" style={{ color: "var(--text-muted)" }}>
                    {t(`contact.channel.${ch.key}.desc`)}
                  </p>
                </div>
              </div>

              {/* Links */}
              <div className="flex flex-col gap-2 mt-4">
                {ch.links.map((link) => (
                  <a
                    key={link.labelKey}
                    href={link.href}
                    target={link.href.startsWith("mailto") ? "_self" : "_blank"}
                    rel="nofollow noopener noreferrer"
                    className="flex items-center gap-2.5 px-4 py-2.5 rounded-lg text-xs font-medium cursor-pointer transition-colors whitespace-nowrap"
                    style={{
                      backgroundColor: "var(--bg-base)",
                      color: "var(--text-nav)",
                      border: "1px solid var(--border-color)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = ch.color;
                      e.currentTarget.style.borderColor = ch.color;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "var(--text-nav)";
                      e.currentTarget.style.borderColor = "var(--border-color)";
                    }}
                  >
                    <i className={`${link.icon} text-sm`}></i>
                    {t(link.labelKey)}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Response time note */}
        <div
          className="mt-8 rounded-xl p-4 flex items-center gap-3"
          style={{ backgroundColor: "rgba(34,197,94,0.06)", border: "1px solid rgba(74,222,128,0.15)" }}
        >
          <i className="ri-time-line text-lg" style={{ color: "var(--accent)" }}></i>
          <p className="text-xs" style={{ color: "var(--text-muted)" }}>
            {t("contact.response.note")}
          </p>
        </div>
      </div>
    </section>
  );
}